export default __webpack_public_path__ + "static/media/Ilhacine_Precos_das_Filmagens_em_Equipamentos_Publicos.b03a6141.pdf";